import type { RefObject } from 'react';
import './ErrorMessage.scss';

const DEFAULT_ERROR_MESSAGE =
  'Der Kommentar kann nicht erfasst werden. Es ist ein technischer Fehler aufgetreten.';

const SRG_LOGIN_NOT_SUPPORTED_MORE_INFO_LINK =
  'https://www.srf.ch/hilfe-kontakt'; // TODO: Change me once the real article is available

// maps server error messages from comments API
type ServerError = 'THREAD_CLOSED' | 'COMMENT_TEXT_NOT_VALID' | 'UNAUTHORIZED';
const SERVER_ERROR_MESSAGES: Record<ServerError, string> = {
  THREAD_CLOSED:
    'Der Kommentar kann nicht erfasst werden. Die Kommentarspalte ist bereits geschlossen.',
  COMMENT_TEXT_NOT_VALID:
    'Der Kommentar kann nicht erfasst werden. Sonderzeichen im Text sind nicht zulässig.',
  UNAUTHORIZED: DEFAULT_ERROR_MESSAGE,
};

type Props = {
  serverMessage: string;
  a11yRef: RefObject<HTMLDivElement>;
};

export const ErrorMessage = ({ serverMessage, a11yRef }: Props) => {
  let uiMessage = DEFAULT_ERROR_MESSAGE;
  if (serverMessage && SERVER_ERROR_MESSAGES[serverMessage as ServerError]) {
    uiMessage = SERVER_ERROR_MESSAGES[serverMessage as ServerError];
  }
  return (
    <div
      ref={a11yRef}
      tabIndex={0}
      className="srf-comments-reply-form-error-message">
      {uiMessage}
    </div>
  );
};

export const SrgLoginNotSupportedErrorMessage = () => {
  return (
    <div
      tabIndex={0}
      className="srf-comments-reply-form-error-message srf-comments-reply-form-error-message--srg">
      Aktualisieren Sie Ihre App, um die Kommentarfunktion weiterhin nutzen zu
      können.{' '}
      <a href={SRG_LOGIN_NOT_SUPPORTED_MORE_INFO_LINK}>
        Weitere Informationen.
      </a>
    </div>
  );
};
